import api from "api/config";

/**
 * SPEC Hotel Integration APIs
 * Base: /api/v1/hotelIntegration/:hotelId/integration
 */

export const getHotelIntegrationConfigAPI = async (hotelId) => {
  const response = await api({
    method: "GET",
    url: `/api/v1/hotelIntegration/${hotelId}/integration`,
  });
  return response.data;
};

/**
 * Save & Activate (create-or-update)
 * - credentials required on create, optional on update
 * - server tests connection before persisting
 */
export const saveHotelIntegrationAPI = async ({ hotelId, data }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration`,
    data,
  });
  return response.data;
};

/**
 * Test connection
 * - draft mode: send payload (no persistence)
 * - persisted mode: send empty object {}
 */
export const testHotelIntegrationAPI = async ({ hotelId, data = {} }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration/test`,
    data,
  });
  return response.data;
};

/**
 * Discover properties/services (for discovery-enabled providers)
 * - draft mode: send payload (no persistence)
 * - persisted mode: send empty object {}
 */
export const discoverHotelIntegrationAPI = async ({ hotelId, data = {} }) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration/discover`,
    data,
  });
  return response.data;
};

/**
 * Generate webhook secret (manual webhook helper)
 */
export const generateHotelIntegrationWebhookSecretAPI = async (hotelId) => {
  const response = await api({
    method: "POST",
    url: `/api/v1/hotelIntegration/${hotelId}/integration/webhook/secret`,
    data: {},
  });
  return response.data;
};


